import {blendColors} from '../../../../core/src/models/helpers/colorHelpers';
import {alphas, greys, greysDark} from '../../styles/colorStyles';
import {colorPrimitive} from '../../styles/primitives/colorPrimitive';
import {redesignedDarkInputSemanticStyles, redesignedLightInputSemanticStyles} from './inputSemanticStyles';

export interface CommentComposerSemanticStyles {
  text: string;
  placeholder: string;
  background: string;
  backgroundHover: string;
  backgroundFocused: string;
  backgroundNoteCard: string;
}

export const lightCommentComposerSemanticStyles = {
  text: greys.black,
  placeholder: colorPrimitive.gray[400],
  background: blendColors(greys.shade20, alphas.gray10),
  backgroundHover: blendColors(greys.shade20, alphas.gray20),
  backgroundFocused: greys.white,
  backgroundNoteCard: greys.white,
} as const satisfies CommentComposerSemanticStyles;

export const darkCommentComposerSemanticStyles: CommentComposerSemanticStyles = {
  text: greysDark.black,
  placeholder: greysDark.shade70,
  background: greysDark.shade20,
  backgroundHover: greysDark.shade30,
  backgroundFocused: greysDark.shade20,
  backgroundNoteCard: redesignedDarkInputSemanticStyles.backgroundSelected,
} as const satisfies CommentComposerSemanticStyles;

export const redesignedLightCommentComposerSemanticStyles: CommentComposerSemanticStyles = {
  ...lightCommentComposerSemanticStyles,
  background: redesignedLightInputSemanticStyles.background,
  backgroundHover: redesignedLightInputSemanticStyles.backgroundHover,
} as const satisfies CommentComposerSemanticStyles;

export const redesignedDarkCommentComposerSemanticStyles: CommentComposerSemanticStyles = {
  ...darkCommentComposerSemanticStyles,
  background: redesignedDarkInputSemanticStyles.background,
  backgroundHover: redesignedDarkInputSemanticStyles.backgroundHover,
  backgroundFocused: redesignedDarkInputSemanticStyles.backgroundSelected,
} as const satisfies CommentComposerSemanticStyles;
